module.exports = __webpack_public_path__ + "static/media/chart-line.3228d264.svg";